import React from 'react'
import { useWrapper } from './Wrapper.hooks'
import { Container } from './Wrapper.styles'

type WrapperProps = {
	children: React.ReactNode
}

export const Wrapper = ({ children }: WrapperProps): JSX.Element => {
	useWrapper()
	return <Container>{children}</Container>
}
